import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=38a88a79&scoped=true&lang=scss"

import exportComponent from "/builds/l1905/conversational-cloud-engineering/conversational-cloud-core/workspaces/agent-workspace/lp-le-custom-management-console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a88a79"]])

export default __exports__